function transformToSections(input) {
  const sections = [];

  function flatten(obj, parentKey = '', result = []) {
    Object.entries(obj).forEach(([key, value]) => {
      const label = parentKey ? `${parentKey} >: ${key}` : key;

      if (value && typeof value === 'object' && !Array.isArray(value)) {
        flatten(value, label, result);
      } else {
        result.push({
          label,
          value: Array.isArray(value) ? value.join(', ') : String(value),
        });
      }
    });

    return result;
  }

  for (const [sectionTitle, sectionData] of Object.entries(input)) {
    const data = flatten(sectionData);
    sections.push({ title: sectionTitle, data });
  }

  return sections.filter(section => !['Conforto', 'Segurança'].includes(section.title));
}

function getEvaluationV2Photos(input) {
  const sections = transformToSections(input);

  const allPhotos = sections.map((section, key) => {
    const inPhotos = section.data.filter(item => item.label.includes('Foto'));

    const photos = inPhotos.map(photo => photo.value.split(','));

    return {
      group: section.title,
      photos: photos[0],
    };
  });

  return {
    items: allPhotos,
  };
}

function checkItemsToHaveDivider(arr) {
  const len = arr.length;

  if (len <= 3) {
    return arr.map(value => ({ value, useDivider: false }));
  }

  return arr.map((value, i) => {
    const position = i + 1;

    let itemsWithoutDivider;

    if (len <= 6) {
      if (len <= 2) {
        itemsWithoutDivider = 0;
      } else {
        itemsWithoutDivider = Math.max(1, len - 3);
      }
    } else {
      if (len % 3 === 1) {
        itemsWithoutDivider = 1;
      } else if (len % 3 === 2) {
        itemsWithoutDivider = 2;
      } else {
        itemsWithoutDivider = 3;
      }
    }

    const useDivider = position <= len - itemsWithoutDivider;

    return { value, useDivider };
  });
}

export { transformToSections, getEvaluationV2Photos, checkItemsToHaveDivider };
